import VTabContext from './context';
import type { VTabContextValue } from './type';

export const useVTab = (): VTabContextValue => VTabContext.hook();
